export default __webpack_public_path__ + "static/media/Fire.85a05965.svg";